import { Component, Method, Prop, h } from "@stencil/core";
import { Column, TableRowWithId } from "../table-interfaces";
import { TableCell } from "../table-cell/table-cell";
import { TableHeader } from "../table-header/table-header";

@Component({
    tag: "uic-table-column-selection",
    styleUrl: "table-column-selection.scss",
    shadow: false,
})
export class TableColumnSelection implements Column {
    /** defines if the column should be a group */
    @Prop() group: boolean = false;

    /** make the render function public */
    @Method()
    async getColumnMethods() {
        return {
            renderCell: this.renderCell.bind(this),
            renderHeader: this.renderHeader.bind(this),
        };
    }

    private testId = "uic-selection";

    private renderHeader(tableState: any) {
        const onChange = (event: Event) => {
            const { checked } = event.target as HTMLUicCheckboxElement;
            if (checked) {
                tableState.selectedRows = tableState.sortedData.map(
                    (row: TableRowWithId) => row._uicTableInternalId
                );
            } else {
                tableState.selectedRows = [];
            }
        };
        const mixed =
            tableState.data &&
            tableState.selectedRows &&
            tableState.selectedRows.length < tableState.data.length &&
            tableState.selectedRows.length !== 0;
        const checked =
            tableState.data &&
            tableState.selectedRows &&
            tableState.selectedRows.length === tableState.data.length;

        return (
            <TableHeader
                group={this.group}
                testId={this.testId}
                initialSortDirection={""}
            >
                <uic-checkbox
                    onUicChange={onChange}
                    mixed={mixed}
                    checked={checked}
                ></uic-checkbox>
            </TableHeader>
        );
    }

    private renderCell(row: TableRowWithId, tableState: any) {
        const onChange = (event: Event) => {
            const { checked } = event.target as HTMLUicCheckboxElement;

            if (checked) {
                tableState.selectedRows = [
                    ...tableState.selectedRows,
                    row._uicTableInternalId,
                ];
            } else {
                tableState.selectedRows = tableState.selectedRows.filter(
                    (rowId: string) => rowId !== row._uicTableInternalId
                );
            }
        };
        return (
            <TableCell testId={this.testId}>
                <uic-checkbox
                    onUicChange={onChange}
                    checked={tableState.selectedRows?.includes(
                        row._uicTableInternalId
                    )}
                ></uic-checkbox>
            </TableCell>
        );
    }
}
